import {makeVar} from "@apollo/client";

export const landmarkDataCache = makeVar(null);
export const selectedLandmarks = makeVar([]);
export const landmarkCustomFieldNames = makeVar(null);